import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const SortHandleIcon = memo(() => (
  <IconWrapper>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25">
      <path
        fill="currentColor"
        d="M4.5 17.35V16.65H19.5V17.35H4.5ZM4.5 12.65V11.95H19.5V12.65H4.5ZM4.5 7.95V7.25H19.5V7.95H4.5Z"
      />
    </svg>
  </IconWrapper>
));
